export const SET_UNNAX_DOCUMENT_FRONT = 'SET_UNNAX_DOCUMENT_FRONT';
export const SET_UNNAX_DOCUMENT_BACK = 'SET_UNNAX_DOCUMENT_BACK';



// WEBPACK FOOTER //
// ./src/actions/unnaxTypes.js